module.exports = __webpack_public_path__ + "static/media/s_sf_12.06cb49bc.png";